'use client'
import React, { useEffect, useState } from 'react'
import TestamonialCard from '@components/TestamonialCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const TestamonialCardSlider = ({ title, description, testamonials, url, dictionary, lang }) => {
    return (
        <section className='w-full pl-3 mt-3 pb-3 border-b-[1px] border-b-forth'>
            {url ? (
                <Link href={`/${url}`}>
                    <h2 className='text-maincolor font-bold text-xl mb-2'>{title[lang]}</h2>
                </Link>
            ) : (
                <h2 className='text-maincolor font-bold text-xl mb-2'>{title[lang]}</h2>
            )}
            {description?.[lang]?.trim() && (
                <p className='text-secondary'>{description[lang]}</p>
            )}
            <div className='sm:block hidden pb-1'>
                <Swiper
                    slidesPerView={4}
                    spaceBetween={16}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    className=''
                >
                    {testamonials.map((testamonial, index) => (
                        <SwiperSlide className='pb-1' key={index} >
                            <TestamonialCard testamonial={testamonial} dictionary={dictionary.card} lang={lang} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className='sm:hidden block'>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1.5}
                        
                    >
                        {testamonials.map((testamonial, index) => (
                            <SwiperSlide className='pb-1' key={index}>
                                <TestamonialCard testamonial={testamonial} dictionary={dictionary.card} lang={lang} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
        </section>
    )
}

export default TestamonialCardSlider